import {sendCustomerOffer} from "@project/sdk/sales";
import {SendCustomerOfferResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";
import {sendCustomerOfferFormSchema} from "./send-customer-offer.schema";
import type {SendCustomerOfferFormPayload} from "./send-customer-offer.schema";

export function sendCustomerOfferMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.sendCustomerOffer,
    retry: false,
    mutationFn: async (payload: SendCustomerOfferFormPayload) =>
      SendCustomerOfferResponse.parse(
        await sendCustomerOffer(id, sendCustomerOfferFormSchema.parse(payload)),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
